import React from 'react';

import { configValue } from 'config/appConfigUtils';
import { getMockFile } from 'hooks/useUpload/getMockFile';

import {
  ImagePickerDropzoneInternal,
  type ImagePickerDropzoneProps,
} from './ImagePickerDropzoneInternal';

export function ImagePickerDropzone(props: ImagePickerDropzoneProps) {
  const isFilestackMock = configValue('filestack', 'mock');

  const getDroppedFile = isFilestackMock
    ? getMockFile
    : // TODO: Fix this from eslint v9 update
      // eslint-disable-next-line @typescript-eslint/require-await
      async (e: React.DragEvent) => e.dataTransfer.files[0];

  const triggerClick = isFilestackMock
    ? async (e: React.UIEvent) => {
        e.preventDefault();
        // eslint-disable-next-line react/destructuring-assignment
        props.onDrop(await getMockFile());
      }
    : (e: React.UIEvent, fileInput: HTMLInputElement) => {
        e.preventDefault();
        fileInput.click();
      };

  return (
    <ImagePickerDropzoneInternal
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      getDroppedFile={getDroppedFile}
      triggerClick={triggerClick}
    />
  );
}
